import axios from 'axios'

//The API host location
const apiHost = '64.227.16.239:1337'

export default {
  data() {
    return {
      categories: []
    }
  },
  getProjects() {

    var _p = 'http://' +
      apiHost +
      '/madsci-projects?_sort=sortOrder:DESC,date:DESC'

    //_p = "/madsci-projects-all.json"
    //console.log(_p)

    return axios
      .create({
        baseURL: _p,
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .get()
  },
  getAdamLassyProjects() {

    var _p = 'http://' +
      apiHost +
      '/Adam-Lassy-Projects'

    //_p = "/madsci-projects.json"

    console.log(_p)

    return axios
      .create({
        baseURL: _p,
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .get()
  },

  getApiHost() {
    return apiHost
  },

  created() {
    //console.log('>>> START STRAPI')
  }
}